import { datadogConfig } from "@/constants/datadog"
export const canInitializeDatadog = () => !!__APP_VERCEL_BRANCH__

/**
 * Sanitizes a tag name for use with Datadog.
 * https://docs.datadoghq.com/getting_started/tagging/#define-tags
 *
 * @param {string} value - The tag name to sanitize.
 * @returns {string|undefined} The sanitized tag name.
 */
export const sanitizeTagName = (value) =>
  value?.toLowerCase().replace(/[^a-z0-9_:./-]/g, "_")

const environment = () => {
  if (__APP_VERCEL_BRANCH__ === "master") {
    return __APP_ENV__
  }
  return sanitizeTagName(__APP_VERCEL_BRANCH__)
}

export const commonDatadogParams = {
  clientToken: import.meta.env.SO_DATADOG_CLIENT_TOKEN,
  site: datadogConfig.site,
  version: __APP_GIT_COMMIT_SHA__,
  env: environment(),
  service: datadogConfig.service,
  sessionSampleRate: 100,
}
